<div class="mt-6 w-full flex flex-col gap-5">
  <h1>{{ 'controlPoints.overview.title' | translate }}</h1>

  <app-control-points-status />

  <app-control-points-history-page />
</div>
